module.exports = __webpack_public_path__ + "static/Facebook sharing image-755697ae737ba3c4ad9d46a80fa59b07.png";